import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AppLayout } from '../components/AppLayout';
import { LegalHealthCheck } from './LegalHealthCheck';
import { useAuth } from '../contexts/AuthContext';
export function LegalHealthCheckAccess() {
  const location = useLocation();
  const navigate = useNavigate();
  const {
    preferences,
    business
  } = useAuth();
  // Determine initial type from navigation state, or fallback to preferences
  const stateType = location.state?.type;
  let initialType: 'personal' | 'business' = 'personal';
  if (stateType === 'business' || stateType === 'personal') {
    initialType = stateType;
  } else if (preferences?.startWith === 'business' && business?.hasBusiness) {
    initialType = 'business';
  }
  // If navigated with explicit state (from dashboard cards), use that view state
  // If clicked from nav bar (no state), show landing page so user can choose type or see history
  const initialViewState = location.state?.viewState || 'landing';
  return <AppLayout data-id="element-1207">
      <LegalHealthCheck embedded={true} initialAssessmentType={initialType} initialViewState={initialViewState} onExit={() => navigate('/app')} data-id="element-1208" />
    </AppLayout>;
}